<template>
  <img
    class="object-cover"
    src="@/assets/images/emojis/emoji-home.png"
  >
</template>